import React from 'react';
import Loadable from 'react-loadable';
import Spinner from '@atlaskit/spinner/spinner';
export var AttachmentAsync = Loadable({
  loader: function loader() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-attachment-field" */'./Attachment').then(function (mod) {
      return mod.Attachment;
    });
  },
  loading: function loading() {
    return /*#__PURE__*/React.createElement(Spinner, null);
  }
});